export enum NAMESPACES {
  PAGES = 'pages',
  PROVIDER = 'provider',
  CATEGORY = 'category',
  ERROR = 'error',
  GAME = 'game',
  INITIAL = 'initial',
  SLIDER = 'slider',
  SEO_TEXTS = 'seotexts',
  MAINTENANCE = 'maintenance',
  META_TAGS = 'metatags',
  CROSS_SALES = 'crosssales',
  BONUS = 'bonus',
}
